export default "__VITE_ASSET__DMtut3HK__"